import * as React from 'react';
import {LayoutContextProps} from './iProvider'

const LayoutContext = React.createContext('vertical')

// eslint-disable-next-line react/prop-types
export const LayoutContextProvider: React.FC<LayoutContextProps> = ({children, layout}) => (
    <LayoutContext.Consumer>
        {originLayout => (
            <LayoutContext.Provider value={layout || originLayout}>{children}</LayoutContext.Provider>
        )}
    </LayoutContext.Consumer>
);

export default LayoutContext;
